import { Dialog } from '@web_opxp/components';
import { useTranslation } from '@web_opxp/features';
import { FC, useState } from 'react';
import { connect } from 'react-redux';
import ENV from '../base/env';
import { IState } from '../store/state';
import './FeedbackDialog.scss';
import { FeedbackFormView } from './FeedbackFormView';
import { FeedbackInitialView } from './FeedbackInitialView';
import { getFeedbackShow } from './selectors';
import { FeedbackActions } from './slice';
import { EFeedbackType } from './types';

export interface IFeedbackDialog {
  show: boolean;
  onSendFeedback: (text: string, rating: EFeedbackType) => void;
}

export const FeedbackDialogFC: FC<IFeedbackDialog> = ({ onSendFeedback, show }) => {
  const { t } = useTranslation();

  const [isInitial, setIsInitial] = useState<boolean>(true);
  const title = isInitial ? t('FeedbackDialog.Initial.Title') : t('FeedbackDialog.Form.Title');
  const header = <h2>{title}</h2>;

  const handlePositiveClick = () => {
    onSendFeedback('', EFeedbackType.positive);
  };

  const handleNegativeClick = () => {
    setIsInitial(false);
  };

  const handleLaterClick = () => {
    onSendFeedback('', EFeedbackType.later);
  };

  const handleSendFeedback = (text: string) => {
    onSendFeedback(text, EFeedbackType.negative);
  };

  const handleCancel = () => {
    setIsInitial(true);
  };

  return (
    <Dialog
      isOpen={show}
      className="feedback-dialog"
      bodyClassName="feedback-body"
      headerClassName="feedback-header"
      headerContent={header}>
      <div className="feedback-content" data-testid="dialog-content">
        <div className="illustration-container">
          <img className="illustration" src={`${ENV.AssetsBaseUrl}/feature/community_1.png`} alt={title} />
        </div>
        <div className="description-container">
          {isInitial ? (
            <FeedbackInitialView
              onHandlePositiveClick={handlePositiveClick}
              onHandleNegativeClick={handleNegativeClick}
              onHandleLaterClick={handleLaterClick}
            />
          ) : (
            <FeedbackFormView onHandleSendFeedback={handleSendFeedback} onHandleCancel={handleCancel} />
          )}
        </div>
      </div>
    </Dialog>
  );
};

export const mapStateToProps = (state: IState) => {
  const show = getFeedbackShow(state);

  return {
    show,
  };
};

export const mapDispatchToProps = {
  onSendFeedback: FeedbackActions.sendFeedback,
};

const FeedbackDialog = connect(mapStateToProps, mapDispatchToProps)(FeedbackDialogFC);
export default FeedbackDialog;
